import { Browser } from "namirasoft-site-react";

export const PasswordExtensionLink: Record<Browser, string | null> = {
    Chrome: "https://chromewebstore.google.com/detail/namirasoft-password/fipanlkjkacopdpnhccphbdgdhmofepm",
    Brave: "https://chromewebstore.google.com/detail/namirasoft-password/fipanlkjkacopdpnhccphbdgdhmofepm",
    Firefox: "https://addons.mozilla.org/en-US/firefox/addon/namirasoft-password/",
    Edge: null,
    Opera: null,
    Safari: null,
    Samsung: null,
    Unknown: null,
}